import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";

import Dialog from "../dialog";
import Booking from "./booking";
import Order from "./order";
import Reaction from "./reaction";
import { styles } from "./styles";
import Snackbar from "../snackbar";
import Header from "../../partials/header";

class Dashboard extends React.Component {
  componentDidMount() {
    const { module } = this.props;
  }
  componentWillReceiveProps(nextProps) {
    if (
      Object.keys(nextProps.module).length > 0 &&
      (!nextProps.module.dashboard || nextProps.module.dashboard.active != 1)
    ) {
      //  không có quyền truy cập dashboard
      this.props.history.push("/profile");
    }
  }
  render() {
    const { classes, theme, t, module } = this.props;
    return (
      <React.Fragment>
        <Dialog onRef={(dialog) => (this.mDialog = dialog)} />
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Header session={t("sidebar_manage")} title={t("sidebar_dashboard")} />
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12}>
            <Reaction />
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={5} className={classes.spacerTop}>
            <Booking />
          </Grid>
          <Grid item xs={12} sm={12} md={7} className={classes.spacerTop}>
            <Order />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  module: state.user.module,
});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(withStyles(styles, { withTheme: true })(Dashboard))
);
